import { UPDATE_STATES } from "Redux/Actions/statesActions";

const INITIAL_STATE = {
  statesData: [],
  groupMemberStatesData: [],
};

const statesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_STATES: {
      return {
        ...state,
        ...action.value,
      };
    }
    default:
      return state;
  }
};

export default statesReducer;
